export const KERALA_DISTRICTS = [
  "Alappuzha",
  "Ernakulam",
  "Idukki",
  "Kannur",
  "Kasaragod",
  "Kollam",
  "Kottayam",
  "Kozhikode",
  "Malappuram",
  "Palakkad",
  "Pathanamthitta",
  "Thiruvananthapuram",
  "Thrissur",
  "Wayanad",
] as const;

export const DISTRICT_COORDINATES: Record<string, { lat: number; lng: number }> = {
  Alappuzha: { lat: 9.4981, lng: 76.3388 },
  Ernakulam: { lat: 9.9816, lng: 76.2999 },
  Idukki: { lat: 9.8494, lng: 76.9749 },
  Kannur: { lat: 11.8745, lng: 75.3704 },
  Kasaragod: { lat: 12.4996, lng: 74.9869 },
  Kollam: { lat: 8.8932, lng: 76.6141 },
  Kottayam: { lat: 9.5916, lng: 76.5222 },
  Kozhikode: { lat: 11.2588, lng: 75.7804 },
  Malappuram: { lat: 11.0510, lng: 76.0711 },
  Palakkad: { lat: 10.7867, lng: 76.6548 },
  Pathanamthitta: { lat: 9.2648, lng: 76.7870 },
  Thiruvananthapuram: { lat: 8.5241, lng: 76.9366 },
  Thrissur: { lat: 10.5276, lng: 76.2144 },
  Wayanad: { lat: 11.6854, lng: 76.1320 },
};

export const CITY_COORDINATES: Record<string, { lat: number; lng: number }> = {
  ...DISTRICT_COORDINATES,
  Kochi: { lat: 9.9312, lng: 76.2673 },
  Trivandrum: { lat: 8.5241, lng: 76.9366 },
  Kakkanad: { lat: 10.0159, lng: 76.3419 },
  Edappally: { lat: 10.0261, lng: 76.3125 },
  Kaloor: { lat: 9.9937, lng: 76.2917 },
  "Panampilly Nagar": { lat: 9.9672, lng: 76.2941 },
  Aluva: { lat: 10.1076, lng: 76.3516 },
  "Fort Kochi": { lat: 9.9658, lng: 76.2421 },
  Palarivattom: { lat: 10.0055, lng: 76.3078 },
  Angamaly: { lat: 10.1960, lng: 76.3860 },
  Muvattupuzha: { lat: 9.9894, lng: 76.5790 },
  Kothamangalam: { lat: 10.0617, lng: 76.6277 },
  Perumbavoor: { lat: 10.1130, lng: 76.4789 },
  Kuttippuram: { lat: 10.8465, lng: 76.0125 },
  Tirur: { lat: 10.9146, lng: 75.9224 },
  Perinthalmanna: { lat: 10.9760, lng: 76.2254 },
  Manjeri: { lat: 11.1202, lng: 76.1211 },
  Ponnani: { lat: 10.7712, lng: 75.9255 },
  Kottakkal: { lat: 10.9984, lng: 75.9961 },
  Nilambur: { lat: 11.2778, lng: 76.2264 },
  Kondotty: { lat: 11.1466, lng: 75.9620 },
  Chalakudy: { lat: 10.3070, lng: 76.3330 },
  Guruvayur: { lat: 10.5946, lng: 76.0416 },
  Kunnamkulam: { lat: 10.6517, lng: 76.0711 },
  Irinjalakuda: { lat: 10.3429, lng: 76.2083 },
  Kodungallur: { lat: 10.2285, lng: 76.1963 },
  Vadakara: { lat: 11.6089, lng: 75.5917 },
  Koyilandy: { lat: 11.4397, lng: 75.6967 },
  Thalassery: { lat: 11.7491, lng: 75.4890 },
  Payyanur: { lat: 12.1009, lng: 75.2045 },
  Taliparamba: { lat: 12.0437, lng: 75.3585 },
  Kanhangad: { lat: 12.3087, lng: 75.0903 },
  Nileshwar: { lat: 12.2536, lng: 75.1408 },
  Kayamkulam: { lat: 9.1764, lng: 76.4997 },
  Cherthala: { lat: 9.6844, lng: 76.3323 },
  Mavelikkara: { lat: 9.2667, lng: 76.5500 },
  Chengannur: { lat: 9.3176, lng: 76.6133 },
  Thodupuzha: { lat: 9.8959, lng: 76.7184 },
  Adimali: { lat: 10.0270, lng: 76.9535 },
  Munnar: { lat: 10.0889, lng: 77.0595 },
  Pala: { lat: 9.7125, lng: 76.6833 },
  Changanassery: { lat: 9.4447, lng: 76.5414 },
  Kanjirappally: { lat: 9.5585, lng: 76.7869 },
  Thiruvalla: { lat: 9.3835, lng: 76.5741 },
  Adoor: { lat: 9.1530, lng: 76.7356 },
  Attingal: { lat: 8.6964, lng: 76.8143 },
  Neyyattinkara: { lat: 8.4004, lng: 77.0874 },
  Varkala: { lat: 8.7379, lng: 76.7163 },
  Nedumangad: { lat: 8.6041, lng: 76.9996 },
  Karunagappally: { lat: 9.0543, lng: 76.5358 },
  Punalur: { lat: 9.0191, lng: 76.9272 },
  Kottarakkara: { lat: 8.9984, lng: 76.7725 },
  "Sultan Bathery": { lat: 11.6629, lng: 76.2570 },
  Kalpetta: { lat: 11.6103, lng: 76.0827 },
  Mananthavady: { lat: 11.8026, lng: 76.0033 },
  Ottapalam: { lat: 10.7735, lng: 76.3813 },
  Chittur: { lat: 10.7027, lng: 76.7214 },
  Mannarkkad: { lat: 10.9891, lng: 76.4601 },
  Shoranur: { lat: 10.7634, lng: 76.2796 },
};

export const DEFAULT_COORDINATES = DISTRICT_COORDINATES["Ernakulam"];

export const POPULAR_LOCATIONS = [...KERALA_DISTRICTS];

/**
 * Safely parses coordinates from GeoJSON [lng, lat] array or lat/lng object.
 * Correctly handles coordinates order for Kerala/India (lat ~8-13, lng ~74-78).
 */
export function parseCoordinates(rawCoords: unknown): { lat: number; lng: number } | null {
  if (!rawCoords) return null;

  if (Array.isArray(rawCoords) && rawCoords.length >= 2) {
    const c0 = Number(rawCoords[0]);
    const c1 = Number(rawCoords[1]);
    if (isNaN(c0) || isNaN(c1) || (c0 === 0 && c1 === 0)) return null;

    // GeoJSON specification is [longitude, latitude].
    // In Kerala/India: lat is ~8-13, lng is ~74-78.
    if (c0 > 50 && c1 < 50) {
      return { lat: c1, lng: c0 };
    } else if (c0 < 50 && c1 > 50) {
      return { lat: c0, lng: c1 };
    }
    return { lat: c1, lng: c0 };
  }

  if (typeof rawCoords === "object" && rawCoords !== null) {
    const obj = rawCoords as Record<string, unknown>;
    const lat = Number(obj.lat ?? obj.latitude);
    const lng = Number(obj.lng ?? obj.longitude ?? obj.lon);
    if (!isNaN(lat) && !isNaN(lng) && (lat !== 0 || lng !== 0)) {
      return { lat, lng };
    }
  }

  return null;
}

/**
 * Resolves fallback coordinates by scanning address text for known Kerala towns or districts.
 */
export function findCoordinatesForAddress(addressText?: string): { lat: number; lng: number } | null {
  if (!addressText || typeof addressText !== "string") return null;
  const lower = addressText.toLowerCase();

  // 1. Search city/town keys first (more specific than districts)
  for (const [city, coords] of Object.entries(CITY_COORDINATES)) {
    const regex = new RegExp(`(^|[^a-z0-9])${city.toLowerCase()}([^a-z0-9]|$)`, "i");
    if (regex.test(lower)) {
      return coords;
    }
  }

  // 2. Search district keys
  for (const [district, coords] of Object.entries(DISTRICT_COORDINATES)) {
    const regex = new RegExp(`(^|[^a-z0-9])${district.toLowerCase()}([^a-z0-9]|$)`, "i");
    if (regex.test(lower)) {
      return coords;
    }
  }

  return null;
}

export function calculateDistanceKm(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number {
  const R = 6371; // km
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

